/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiSegmentFullCalculationState } from './InternalApiSegmentFullCalculationState';
import {
    InternalApiSegmentFullCalculationStateFromJSON,
    InternalApiSegmentFullCalculationStateFromJSONTyped,
    InternalApiSegmentFullCalculationStateToJSON,
    InternalApiSegmentFullCalculationStateToJSONTyped,
} from './InternalApiSegmentFullCalculationState';

/**
 * 
 * @export
 * @interface InternalApiEntityGroup
 */
export interface InternalApiEntityGroup {
    /**
     * 
     * @type {number}
     * @memberof InternalApiEntityGroup
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiEntityGroup
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiEntityGroup
     */
    rule: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiEntityGroup
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiEntityGroup
     */
    versionCode?: string;
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiEntityGroup
     */
    entityType: InternalApiEntityType;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiEntityGroup
     */
    inSync?: boolean;
    /**
     * 
     * @type {InternalApiSegmentFullCalculationState}
     * @memberof InternalApiEntityGroup
     */
    fullCalculationState?: InternalApiSegmentFullCalculationState;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiEntityGroup
     */
    archivedAt?: Date;
}



/**
 * Check if a given object implements the InternalApiEntityGroup interface.
 */
export function instanceOfInternalApiEntityGroup(value: object): value is InternalApiEntityGroup {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rule' in value) || value['rule'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    return true;
}

export function InternalApiEntityGroupFromJSON(json: any): InternalApiEntityGroup {
    return InternalApiEntityGroupFromJSONTyped(json, false);
}

export function InternalApiEntityGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiEntityGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'rule': json['rule'],
        'code': json['code'],
        'versionCode': json['versionCode'] == null ? undefined : json['versionCode'],
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
        'inSync': json['in_sync'] == null ? undefined : json['in_sync'],
        'fullCalculationState': json['full_calculation_state'] == null ? undefined : InternalApiSegmentFullCalculationStateFromJSON(json['full_calculation_state']),
        'archivedAt': json['archivedAt'] == null ? undefined : (new Date(json['archivedAt'])),
    };
}

export function InternalApiEntityGroupToJSON(json: any): InternalApiEntityGroup {
    return InternalApiEntityGroupToJSONTyped(json, false);
}

export function InternalApiEntityGroupToJSONTyped(value?: InternalApiEntityGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'rule': value['rule'],
        'code': value['code'],
        'versionCode': value['versionCode'],
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'in_sync': value['inSync'],
        'full_calculation_state': InternalApiSegmentFullCalculationStateToJSON(value['fullCalculationState']),
        'archivedAt': value['archivedAt'] == null ? value['archivedAt'] : value['archivedAt'].toISOString(),
    };
}

